import { render, staticRenderFns } from "./CompanyDetailConfirmDialog.vue?vue&type=template&id=5c1394d5&scoped=true&"
import script from "./CompanyDetailConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetailConfirmDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDetailConfirmDialog.vue?vue&type=style&index=0&id=5c1394d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1394d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VCard,VCardActions,VCardText,VDialog,VDivider,VSpacer,VToolbarTitle})
